var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _rect;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgImg1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 148,
    height: 148,
    viewBox: "0 0 148 148",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M50.1582 46.0213C50.0956 42.4482 56.0537 38.7301 63.1136 38.8954C70.1735 39.0608 76.7283 42.6384 75.7344 46.6163C74.8247 50.2428 69.1108 53.5419 62.0509 53.3766C54.991 53.2112 50.2231 49.593 50.1601 46.0218L50.1582 46.0213Z",
    stroke: "#E17D55",
    strokeWidth: 0.8,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M57.2543 45.6708C57.2923 43.9815 59.7601 42.6691 62.7696 42.7398C65.7748 42.8112 68.5669 44.2887 68.147 45.9262C67.7598 47.4205 65.3291 48.7765 62.3196 48.7058C59.3101 48.6352 57.2144 47.3596 57.2524 45.6703L57.2543 45.6708V45.6708Z",
    stroke: "#E17D55",
    strokeWidth: 0.8,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M57.6937 46.9712C57.6308 46.7798 57.6014 46.5795 57.6051 46.3721L57.607 46.3727C57.6422 44.8085 59.9244 43.5956 62.708 43.6613C65.4891 43.7283 68.0715 45.094 67.6827 46.6084C67.654 46.7157 67.6152 46.8222 67.5644 46.9273",
    stroke: "#E17D55",
    strokeWidth: 0.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M58.0387 47.2311C58.029 47.1498 58.0241 47.0659 58.0255 46.9817L58.0274 46.9823C58.0607 45.5041 60.2187 44.3567 62.8506 44.4181C65.2522 44.4754 67.498 45.5589 67.5882 46.8372",
    stroke: "#E17D55",
    strokeWidth: 0.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M61.4794 48.7023L67.2135 46.0032",
    stroke: "#E17D55",
    strokeWidth: 0.8,
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M58.0283 47.3394L64.066 44.4963",
    stroke: "#E17D55",
    strokeWidth: 0.8,
    strokeMiterlimit: 10
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M74.5393 55.6126C73.3459 57.0717 68.5773 61.3269 59.7099 60.1708C50.8426 59.0147 50.7133 54.853 50.7133 54.853",
    stroke: "#E17D55",
    strokeWidth: 0.8,
    strokeMiterlimit: 10
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M57.5545 52.8404L57.9445 53.6785L58.5191 53.7648C58.5191 53.7648 59.0676 53.2288 59.1211 53.1286",
    stroke: "#E17D55",
    strokeWidth: 0.8,
    strokeMiterlimit: 10
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M57.9469 53.6772L58.2119 59.8524",
    stroke: "#E17D55",
    strokeWidth: 0.8,
    strokeMiterlimit: 10
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M58.519 53.7651L58.894 59.9389",
    stroke: "#E17D55",
    strokeWidth: 0.8,
    strokeMiterlimit: 10
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M74.5994 52.6503C74.892 49.8641 77.5352 48.7258 77.5352 48.7258C79.3455 47.7965 93.17 42.1516 94.9208 41.199C96.6717 40.2464 99.1801 37.9924 99.1408 35.924C99.0656 32.0997 93.2974 29.1087 86.2578 29.2401",
    stroke: "#E17D55",
    strokeWidth: 0.8,
    strokeMiterlimit: 10
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M50.2004 46.5371C50.2004 46.5371 54.6403 117.268 54.7736 118.483C54.907 119.697 54.9122 123.268 62.5331 124.446C70.1541 125.625 74.9084 120.086 74.9084 120.086",
    stroke: "#E17D55",
    strokeWidth: 0.8,
    strokeMiterlimit: 10
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M86.4962 41.4496C91.874 41.3497 96.1875 38.9015 96.1306 35.9813C96.0737 33.0611 91.668 30.7747 86.2901 30.8746C80.9123 30.9745 76.5989 33.4227 76.6558 36.3429C76.7126 39.2631 81.1184 41.5495 86.4962 41.4496Z",
    stroke: "#E17D55",
    strokeWidth: 0.8,
    strokeMiterlimit: 10
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M86.6694 41.4476C91.7938 41.3525 95.904 39.019 95.8498 36.2357C95.7956 33.4525 91.5974 31.2733 86.473 31.3685C81.3485 31.4636 77.2383 33.7971 77.2925 36.5804C77.3468 39.3636 81.5449 41.5428 86.6694 41.4476Z",
    stroke: "#E17D55",
    strokeWidth: 0.8,
    strokeMiterlimit: 10
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M96.1307 106.192C96.3975 102.177 100.172 37.3728 100.172 37.3728C100.172 37.3728 100.463 34.4191 95.927 31.4409C93.5613 30.026 90.0998 29.1675 86.2602 29.2385C85.6911 29.2486 85.1323 29.2803 84.5849 29.3296C82.9016 29.4268 81.1915 29.7473 79.5194 30.382C73.4718 32.6755 62.2818 37.1404 61.1205 37.7235C59.9592 38.3066 59.6114 38.6835 59.4744 39.1106L60.6057 38.9996C63.2231 37.173 68.2631 38.4655 71.1174 39.4594C73.9722 40.4513 77.7068 43.536 76.8701 46.3312C76.5276 47.4752 75.8029 48.5611 75.4191 49.4167C74.6086 51.2125 74.5421 53.232 74.5355 53.8099C74.5228 55.0649 74.9123 120.087 74.9123 120.087C74.9123 120.087 75.0881 121.016 76.076 120.642C77.0639 120.267 91.0955 112.552 91.6662 112.212C92.235 111.872 95.8659 110.208 96.1326 106.193L96.1307 106.192Z",
    stroke: "#E17D55",
    strokeWidth: 0.8,
    strokeMiterlimit: 10
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 147,
    height: 147,
    rx: 73.5,
    stroke: "#E17D55"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImg1);
export default __webpack_public_path__ + "static/media/img1.9a4360e71a2c05fed5da205d8d8e6a31.svg";
export { ForwardRef as ReactComponent };